import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';

import { AutoSubOnDestroy, AutoSub, MoteService, UserService } from '../../providers';
import { Mote, MoteState, MoteType, MotesPaths } from '../../models';
import { MoteEvent, MoteEventType, MoteTypeIconMap } from '../../models';
import { Animations } from '../../animations';

@AutoSubOnDestroy()
@Component({
    selector: 'list-mote',
    templateUrl: './list-mote.component.html',
    styleUrls: ['./list-mote.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [Animations.fadeIn()]
})
export class ListMoteComponent implements OnInit {

    // Inputs
    @Input() set moteInput(mote: Mote) { this.updateMote(mote) };
    @Input() moteKey: string = null;
    @Input() delay: number = 0;

    //Outputs
    @Output() moteEvent = new EventEmitter<MoteEvent>();

    // Show action buttons two-way binding
    @Input() showActionButtons: boolean = false;
    @Output() showActionButtonsChange: EventEmitter<boolean> = new EventEmitter();

    public mote: Mote = null;
    public hideListMote: boolean = true;
    public usePlaceholderImg: boolean = false;

    // Expose enums to view
    public MoteType = MoteType;
    public MoteState = MoteState;
    public MoteEventType = MoteEventType;
    public MoteTypeIconMap = MoteTypeIconMap;
    public MotesPaths = MotesPaths;

    constructor(private cd: ChangeDetectorRef, private moteService: MoteService, private userService: UserService) { }

    private updateMote(mote: Mote) {
        // Save mote in component
        this.mote = mote;
        // Show changes in view
        this.cd.markForCheck();
        // Subscribe for changes to this mote
        AutoSub(this).reg['moteUpdate'] = this.mote.watchUpdates().subscribe(mote => {
            this.cd.markForCheck();
        });

        if(this.mote.type == MoteType.PLACE) return;
        this.mote.childCount = 0;
        for(let key in Mote.moteCache) {
            if(Mote.moteCache[key].parent == this.mote.key) this.mote.childCount++;
        }
    }

    ngOnInit() {
        if(this.mote) this.animateMote(this.delay);
        else if(this.moteKey) {
            AutoSub(this).reg['mote'] = this.moteService.watchMote(this.moteKey).subscribe((mote) => {
                this.updateMote(mote);
                this.animateMote(this.delay);
            })
        }
    }

    private animateMote(delay: number = 0): void {
        setTimeout(() => {
            this.hideListMote = false;
            if(!this.mote.image || !this.mote.image.thumb.url) this.noImage();
            this.cd.markForCheck();
        }, delay);
    }

    public noImage(ev: any = null) {
        this.usePlaceholderImg = true;
    }

    public emitEvent(type: MoteEventType, options = null) {
        this.moteEvent.emit({ mote: this.mote, type: type, options: options });
    }

    public removeFromUnlocked(): void {
        let user = this.userService.currentUser;
        if(!user) return alert($localize`It seems that you are not logged in?`);
        this.userService.removeUnlockedMote(user, this.moteKey || this.mote.key);
    }

}
